// @flow
/* eslint react/jsx-no-bind:0 */

import React, { Component } from 'react';
import BusinessAccountCreate from 'app/common/react/components/partner/BusinessAccount/BusinessAccountCreate/BusinessAccountCreate';
import changeWindowLocation from 'app/common/lib/util/changeWindowLocation';
import ErrorToast from 'app/common/react/components/growth/unauth/Toast/ErrorToast';
import FacebookConnectButton from 'app/common/react/components/growth/unauth/signup/FacebookConnectButton/FacebookConnectButton';
import FullPageSignup from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignup';
import GoogleOneTapPresenter from 'app/common/react/components/growth/unauth/signup/GoogleOneTap/GoogleOneTapPresenter';
import i18n from 'app/common/lib/i18n';
import LoadingMask from 'app/common/react/components/growth/unauth/signup/LoadingMask/LoadingMask';
import LoginMfa from 'app/common/react/components/growth/unauth/signup/LoginMfa/LoginMfa';
import logo from 'app/common/react/components/growth/unauth/lib/images/logo';
import nameFromEmail from 'app/packages/infer-name-from-email';
import PropTypes from 'prop-types';
import Signup from 'app/common/react/components/growth/unauth/signup/Signup/Signup';
import SignupWelcomeLoading from 'app/common/react/components/growth/unauth/signup/SignupWelcomeLoading/SignupWelcomeLoading';
import SocialConnectAgeCollection from 'app/common/react/components/growth/unauth/signup/SocialConnectAgeCollection/SocialConnectAgeCollection';
import trackRegisterAction from 'app/common/lib/util/trackRegisterAction';
import type { FacebookUserData } from 'app/packages/pinterest-flow-types/authentication';
import type { GenericAuthenticationCredsType } from 'app/packages/pinterest-authentication/registration';
import type { SignupCredentialsAndLoggingData } from 'app/packages/pinterest-flow-types/registration';
import urlUtil from 'app/common/lib/urlUtil';
import { compose } from 'redux';
import { FullPageSignupToggleType } from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupToggleType';
import { MultiTreatmentExp } from 'app/common/lib/experiment';
import { SignupSource } from 'app/common/react/components/growth/unauth/signup/constants';
import { track } from 'app/common/lib/react/analytics';
import withUnauthSeoExperiments, {
  type UnauthSeoExperiments,
} from 'app/common/lib/react/withUnauthSeoExperiments';
import {
  getEnabledGroup,
  renderValuePropComponent,
} from 'app/common/react/components/growth/smb/CreateAccountValueProp/';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';
import { Box, Button, Column, Text, Touchable } from 'gestalt';

export const CONTENT_TYPE = {
  MFA: 'mfa',
  SIGNUP: 'signup',
  SOCIAL_CONNECT_AGE_COLLECTION: 'socialConnectAgeCollection',
  FB_EMAIL_REREQUEST: 'FBEmailRerequest',
  EMAIL_CONFIRMATION: 'emailConfirmation',
};

type OwnProps = {|
  container: string,
  email?: string,
  onLoginClick: () => void,
  sm?: string,
  handleShowingSignupWelcomeLoading?: (boolean) => void,
  shouldRenderErrorToast?: boolean,
  errorMessage?: string,
|};

type Props = {|
  ...OwnProps,
  seoUnauthExperiments: UnauthSeoExperiments,
  requestContext: RequestContextType,
  homepageButtonExpShowLogin: boolean,
  homepageButtonExpIsPersonalAccount: boolean,
|};

type contentTypeValues = $Values<typeof CONTENT_TYPE>;

type State = {|
  email: string,
  emailValidationError: ?string,
  showLoadingIndicator: boolean,
  password: string,
  age: ?string,
  gender: string,
  mfaCode: string,
  mfaCreds?: Object,
  mfaPhoneNumberEnd?: string,
  name: string,
  passwordValidationError: ?string,
  registrationCredentials: ?GenericAuthenticationCredsType,
  step: contentTypeValues,
  scrolling: boolean,
  personalAccountType: boolean,
  showSignupWelcomeLoading: boolean,
  fullPageModalType: string,
|};

const styles = {
  giftWrap: {
    background: 'none',
    bottom: '0px',
    left: '0px',
    position: 'fixed',
    right: '0px',
    top: '0px',
    minWidth: '800px',
  },
  spacingWrapper: {
    paddingBottom: '67px',
    paddingTop: '48px',
    minHeight: '533px',
    left: '50%',
    top: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
  contentWrapper: {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0',
    right: '0',
    overflow: 'auto',
  },
  spacingWrapperScrolling: {
    paddingBottom: '67px',
    paddingTop: '48px',
    minHeight: '533px',
    left: '50%',
    position: 'absolute',
    transform: 'translateX(-50%)',
  },
  contentWrapperScrolling: {
    position: 'absolute',
    top: '0px',
    bottom: '0px',
    left: '0',
    right: '0',
    overflow: 'auto',
  },
  brioModal: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    minHeight: '533px',
    paddingTop: '10px',
  },
  brioLogo: {
    margin: '14px auto 0',
    position: 'relative',
    height: '55px',
    width: '55px',
  },
  brioTitle: {
    margin: '5px 26px 26px',
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '28px',
    color: '#333',
  },
  brioTitleMfa: {
    padding: '0 10px',
  },
  brioInputFields: {
    backgroundColor: '#f0f0f0',
    border: '0px',
    outline: 'none',
  },
  brioModalWrapper: {
    position: 'static',
    height: '100%',
    width: '100%',
  },
  subtitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#ccc',
    fontSize: '18px',
    margin: '-25px 26px 20px',
  },
  confirmationMessage: {
    textAlign: 'center',
    color: 'rgb(85, 85, 85)',
    fontSize: '16px',
    margin: '32px 0px',
  },
  confirmationButton: {
    width: '270px',
    margin: 'auto',
  },
  signupForm: {
    margin: '16px 0',
    position: 'relative',
  },
};

export class InspiredWallSignup extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      email: props.email || '',
      emailValidationError: null,
      showLoadingIndicator: false,
      password: '',
      age: undefined,
      gender: '',
      mfaCode: '',
      mfaPhoneNumberEnd: '',
      name: '',
      passwordValidationError: null,
      registrationCredentials: null,
      step: CONTENT_TYPE.SIGNUP,
      scrolling: typeof window === 'undefined' ? false : window.innerHeight < 800,
      personalAccountType: props.homepageButtonExpIsPersonalAccount !== false,
      showSignupWelcomeLoading: false,
      fullPageModalType: props.homepageButtonExpShowLogin ? 'login' : 'signup',
    };
  }

  componentDidMount() {
    this.isScrolling();
    window.addEventListener('resize', this.isScrolling.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.isScrolling.bind(this));
  }

  setLoadingIndicator = (showLoadingIndicator: boolean) => {
    this.setState({ showLoadingIndicator });
  };

  setNameFromEmail() {
    this.setState({ name: nameFromEmail(this.state.email) });
  }

  getLoginUrl = () =>
    this.state.personalAccountType
      ? '/login'
      : urlUtil.buildRelativeUrl('/login', { next: '/business/create/' });

  toggleModalType = () =>
    this.setState(({ fullPageModalType }) => {
      if (fullPageModalType === 'login') {
        return { fullPageModalType: 'signup' };
      }
      return { fullPageModalType: 'login' };
    });

  isScrolling() {
    this.setState({ scrolling: window.innerHeight < 800 });
  }

  CONTAINER_ID = 'InspiredWallSignup'; // 'InspiredWallSignup' DO NOT CHANGE

  showAdditionalStep = (stepName: contentTypeValues) => (
    network: string,
    userData: FacebookUserData | { email?: string },
    credentialsAndLoggingData: SignupCredentialsAndLoggingData,
  ) => {
    this.setState({
      step: stepName,
      registrationCredentials: {
        type: network,
        userData,
        credentialsAndLoggingData,
      },
    });
  };

  handleDataChange(field: string, e: SyntheticInputEvent<HTMLInputElement> & { value: string }) {
    const data = {};
    // Nonnative form controls such as SelectList doesn't work with event.target browser property. The onChange event
    // doesn't return payload with target field so we need to check for target
    data[field] = (e.target && e.target.value) || e.value;
    this.setState(data);
  }

  handleLoginWithMfa(data: { phone_number_end: ?string }, creds: Object) {
    const newState = {};
    newState.step = CONTENT_TYPE.MFA;
    newState.mfaCreds = creds;
    if (data && data.phone_number_end) {
      newState.mfaPhoneNumberEnd = data.phone_number_end;
    }
    this.setState(newState);
  }

  handlePostConnectClick = () => {
    trackRegisterAction('unauth.fb_email_reauth.post_connect.click');
  };

  handlePostSuccessConnect = () => {
    trackRegisterAction('unauth.fb_email_reauth.post_success.connect');
  };

  changeStep(step: contentTypeValues) {
    this.setState({ step });
  }

  clearPassword = () => {
    this.setState({ password: '' });
  };

  showSignupWelcomeLoadingFn = (shouldShow: boolean) => {
    this.setState({
      showSignupWelcomeLoading: shouldShow,
    });
    if (this.props.handleShowingSignupWelcomeLoading) {
      this.props.handleShowingSignupWelcomeLoading(shouldShow);
    }
  };

  renderLoadingIndicator() {
    if (!this.state.showLoadingIndicator) {
      return null;
    }

    return <LoadingMask />;
  }

  renderBrioTitle() {
    if (this.state.step === CONTENT_TYPE.FB_EMAIL_REREQUEST) {
      return (
        <div>
          <div style={styles.brioTitle}>
            {i18n._('Add your email to finish', 'Tagline on facebook rerequest form on home page')}
          </div>
        </div>
      );
    } else if (this.state.step === CONTENT_TYPE.EMAIL_CONFIRMATION) {
      return (
        <div>
          <div style={styles.brioTitle}>
            {i18n._('Check your email', 'headline for email confirmation step')}
          </div>
        </div>
      );
    } else if (this.state.step === CONTENT_TYPE.SOCIAL_CONNECT_AGE_COLLECTION) {
      return (
        <div>
          <div style={styles.brioTitle}>{i18n._('Sign up to see more')}</div>
        </div>
      );
    } else if (this.state.step === CONTENT_TYPE.MFA) {
      return (
        <div>
          <div style={{ ...styles.brioTitle, ...styles.brioTitleMfa }}>
            {i18n._('Two-Factor Authentication Required')}
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div style={styles.brioTitle}>
            {i18n._('Welcome to Pinterest', 'Title on desktop signup modal on home page')}
          </div>
          <div style={styles.subtitle}>
            {i18n._('Find new ideas to try', 'Value prop on desktop signup modal on home page')}
          </div>
        </div>
      );
    }
  }

  renderMainComponent() {
    const { step, registrationCredentials } = this.state;
    if (step === CONTENT_TYPE.FB_EMAIL_REREQUEST) {
      const reRequestFormStyle = { width: '320px', margin: 'auto' };
      const FBbuttonStyle = { width: '260px', margin: 'auto' };
      const notNowButtonStyle = { width: '268px', margin: 'auto', marginTop: '96px' };
      const message = i18n._(
        'We need your email address to complete this signup. Click the button below, and we can use the email associated with your Facebook account.',
        'message to explain reauth step beneath the tagline on homepage',
      );
      return (
        <div style={reRequestFormStyle}>
          <div style={styles.confirmationMessage}>{message}</div>
          <div style={FBbuttonStyle}>
            <FacebookConnectButton
              isRerequest
              container="FBEmailRerequest"
              buttonText={i18n._(
                'Continue with Facebook',
                'Button text on facebook connect button on FB email reauth form',
              )}
              loadingIndicatorCallback={this.setLoadingIndicator}
              useGestaltTooltip
              handlePostConnectClick={this.handlePostConnectClick}
              handlePostSuccessConnect={this.handlePostSuccessConnect}
            />
          </div>
          <div style={notNowButtonStyle}>
            <Button
              text={i18n._(
                'Not now',
                'word on not now button to dismiss the FB email reauth form on homepage',
              )}
              onClick={() => {
                this.changeStep(CONTENT_TYPE.SIGNUP);
              }}
              color="gray"
              size="md"
            />
          </div>
        </div>
      );
    } else if (step === CONTENT_TYPE.EMAIL_CONFIRMATION) {
      const confirmationMessage = i18n._(
        "We've sent a confirmation email to ",
        'email confirmation message for Facebook cellphone only sign up',
      );
      return (
        <div>
          <div style={styles.confirmationMessage}>
            {confirmationMessage}
            {registrationCredentials && registrationCredentials.userData.email}
          </div>
          <div style={styles.confirmationButton}>
            <Button
              text={i18n._('Done', 'word on the button in email confirmatiobn page')}
              color="red"
              size="md"
              onClick={this.changeStep.bind(this, CONTENT_TYPE.SIGNUP)}
            />
          </div>
        </div>
      );
    } else if (step === CONTENT_TYPE.SOCIAL_CONNECT_AGE_COLLECTION && registrationCredentials) {
      return (
        <Box>
          <SocialConnectAgeCollection
            container={this.props.container}
            disablePostSignupNextUrl
            loadingIndicatorCallback={this.setLoadingIndicator}
            registrationCredentials={registrationCredentials}
            showSignupWelcomeLoadingFn={this.showSignupWelcomeLoadingFn}
          />
        </Box>
      );
    } else if (step === CONTENT_TYPE.MFA) {
      return (
        <LoginMfa
          container={this.props.container || 'inspired_banner_mfa'}
          code={this.state.mfaCode}
          creds={this.state.mfaCreds}
          email={this.state.email}
          inputStyleOverrides={styles.brioInputFields}
          onCodeChange={this.handleDataChange.bind(this, 'mfaCode')}
          password={this.state.password}
          phoneNumberEnd={this.state.mfaPhoneNumberEnd}
        />
      );
    } else {
      return (
        <Box>
          <Signup
            age={this.state.age}
            container={this.props.container}
            email={this.state.email}
            emailValidationError={this.state.emailValidationError}
            gender={this.state.gender}
            loadingIndicatorCallback={this.setLoadingIndicator}
            name={this.state.name}
            passwordValidationError={this.state.passwordValidationError}
            onAgeChange={this.handleDataChange.bind(this, 'age')}
            onEmailChange={this.handleDataChange.bind(this, 'email')}
            onSocialConnectVerified={this.showAdditionalStep(
              CONTENT_TYPE.SOCIAL_CONNECT_AGE_COLLECTION,
            )}
            onFBEmailDeniedPerm={this.showAdditionalStep(CONTENT_TYPE.FB_EMAIL_REREQUEST)}
            onGenderChange={this.handleDataChange.bind(this, 'gender')}
            onLoginWithMfa={this.handleLoginWithMfa.bind(this)}
            onNameChange={this.handleDataChange.bind(this, 'name')}
            onPasswordChange={this.handleDataChange.bind(this, 'password')}
            onStepChange={this.changeStep.bind(this)}
            password={this.state.password}
            showSignupWelcomeLoadingFn={this.showSignupWelcomeLoadingFn}
            setNameFromEmail={this.setNameFromEmail.bind(this)}
            sm={this.props.sm}
            clearPassword={this.clearPassword}
          />
        </Box>
      );
    }
  }

  renderPartnerTitle() {
    return (
      <div>
        <div style={styles.brioTitle}>{i18n._('Welcome to Pinterest')}</div>
        <div style={styles.subtitle}>{i18n._('Grow your business')}</div>
      </div>
    );
  }

  renderBusinessCreateButton = () => {
    const { personalAccountType, step } = this.state;

    return step === CONTENT_TYPE.FB_EMAIL_REREQUEST ? null : (
      <Box
        height={62}
        shape="roundedBottom"
        color="lightGray"
        position="absolute"
        bottom
        left
        width="100%"
      >
        <Touchable
          onTouch={({ event }) => {
            this.setState(({ personalAccountType }) => ({
              personalAccountType: !personalAccountType,
            }));

            trackRegisterAction(
              personalAccountType
                ? 'unauth.home.pinner_business_toggle.pinner.click'
                : 'unauth.home.pinner_business_toggle.business.click',
            );

            track(PCONST.thrift.EventType.CLICK, {
              component: PCONST.thrift.ComponentType.SIGNUP_FORM,
              element: PCONST.thrift.ElementType.PINNER_BUSINESS_TOGGLE,
              is_business_signup: !personalAccountType,
            });
          }}
          fullHeight
        >
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <Text weight="bold">
              {personalAccountType
                ? i18n._('Create a business account')
                : i18n._('Create a personal account')}
            </Text>
          </Box>
        </Touchable>
      </Box>
    );
  };

  renderUnifiedSignup() {
    const { personalAccountType } = this.state;
    const { requestContext } = this.props;
    const unifiedSignupValuePropExp = new MultiTreatmentExp(
      requestContext,
      'smb_web_unified_signup_value_prop',
    );

    const modalStylesBottom = { ...styles.brioModal, width: '400px' };

    if (!personalAccountType) {
      const expEnableGroup = getEnabledGroup(unifiedSignupValuePropExp);
      if (expEnableGroup) {
        return this.renderWithValueProp(expEnableGroup);
      }
    }

    return (
      <div style={modalStylesBottom}>
        {this.renderLoadingIndicator()}
        <Box display="flex" direction="row" justifyContent="between" alignItems="center">
          <Box width={400}>
            <div style={styles.brioModalWrapper}>
              <div style={styles.brioLogo}>{logo(50, true)}</div>
              {personalAccountType ? this.renderBrioTitle() : this.renderPartnerTitle()}
              {personalAccountType ? (
                this.renderMainComponent()
              ) : (
                <BusinessAccountCreate isAuth={false} unifiedSignup />
              )}
              <Box height={62} shape="roundedBottom" marginTop={3} />
              {this.renderBusinessCreateButton()}
            </div>
          </Box>
        </Box>
      </div>
    );
  }

  renderWithValueProp(enabledGroup: string) {
    const modalStylesBottom = { ...styles.brioModal, width: '800px' };

    return (
      <div style={modalStylesBottom}>
        {this.renderLoadingIndicator()}
        <div style={styles.brioModalWrapper}>
          <Box>
            <Column span={0} mdSpan={6}>
              <Box
                dangerouslySetInlineStyle={{
                  __style: {
                    borderRight: 'solid 1px #D8D8D8',
                  },
                }}
              >
                {renderValuePropComponent(enabledGroup)}
              </Box>
            </Column>
            <Column xs={6} md={6}>
              <Box display="flex" direction="column" alignItems="center" marginTop={7}>
                <Box>
                  <div style={styles.brioLogo}>{logo(50, true)}</div>
                  {this.renderPartnerTitle()}
                  <BusinessAccountCreate unifiedSignup />
                  <Box height={62}>
                    <Touchable
                      onTouch={({ event }) => {
                        this.setState(({ personalAccountType }) => ({
                          personalAccountType: true,
                        }));

                        trackRegisterAction('unauth.home.pinner_business_toggle.business.click');

                        track(PCONST.thrift.EventType.CLICK, {
                          component: PCONST.thrift.ComponentType.SIGNUP_FORM,
                          element: PCONST.thrift.ElementType.PINNER_BUSINESS_TOGGLE,
                          is_business_signup: true,
                        });
                      }}
                      fullHeight
                    >
                      <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <Text weight="bold">{i18n._('Create a personal account')}</Text>
                      </Box>
                    </Touchable>
                  </Box>
                </Box>
              </Box>
            </Column>
          </Box>
        </div>
      </div>
    );
  }

  renderErrorToast() {
    const errorTitle =
      this.props.errorMessage || i18n._('Something went wrong.', 'Default error message');

    return (
      <Box display="flex" alignItems="center" justifyContent="center" minHeight={73} marginTop={8}>
        <ErrorToast color="red" text={errorTitle} />
      </Box>
    );
  }

  render() {
    const { email, shouldRenderErrorToast } = this.props;
    const { personalAccountType, fullPageModalType } = this.state;

    return (
      <div
        data-test-id="signup"
        style={{
          height: '100%',
        }}
      >
        {this.state.showSignupWelcomeLoading ? (
          <SignupWelcomeLoading />
        ) : (
          <Box position="relative" height="100%">
            {personalAccountType ? (
              <Box display="flex" direction="column" justifyContent="center" height="100%">
                {shouldRenderErrorToast && this.renderErrorToast()}
                <div style={styles.signupForm}>
                  <FullPageSignup
                    container="home_page"
                    email={email}
                    signupSource={SignupSource.homePage}
                    type={fullPageModalType}
                    handleModalTypeSwitch={this.toggleModalType}
                    toggleType={FullPageSignupToggleType.SMALL_TOGGLE}
                    renderBusinessCreateButton={this.renderBusinessCreateButton}
                    handleShowingSignupWelcomeLoading={this.showSignupWelcomeLoadingFn}
                    mfaCreds={this.state.mfaCreds}
                    languageLocation="homePage"
                    toggleModalType={this.toggleModalType}
                  />
                </div>
              </Box>
            ) : (
              <div
                style={
                  this.state.scrolling ? styles.contentWrapperScrolling : styles.contentWrapper
                }
              >
                <div
                  style={
                    this.state.scrolling ? styles.spacingWrapperScrolling : styles.spacingWrapper
                  }
                >
                  <Box position="relative">{this.renderUnifiedSignup()}</Box>
                </div>
              </div>
            )}
            <Box
              alignItems="stretch"
              data-test-id={fullPageModalType === 'login' ? 'signup-button' : 'login-button'}
              height={9}
              left
              top
              marginLeft={6}
              marginTop={12}
              minWidth={130}
              position="absolute"
            >
              <Button
                onClick={() => {
                  if (personalAccountType) {
                    trackRegisterAction('unauth.home.toggle.click');
                    this.toggleModalType();
                  } else {
                    changeWindowLocation(this.getLoginUrl());
                  }
                }}
                text={
                  fullPageModalType === 'login'
                    ? i18n._('Sign up', 'sign up for account toggle on homepage')
                    : i18n._('Log in')
                }
              />
            </Box>
            <GoogleOneTapPresenter
              container={this.CONTAINER_ID}
              handleSignupError={() => {}}
              handleLoginWithMfa={(creds) => {
                this.setState({
                  step: CONTENT_TYPE.MFA,
                  mfaCreds: creds,
                  fullPageModalType: 'loginMfa',
                });
              }}
              handleLoginError={(error) => {
                if (error.type === 'email') {
                  // failed input validation
                  this.setState({ emailValidationError: error.message });
                } else if (error.type === 'password') {
                  // failed input validation
                  this.setState({ passwordValidationError: error.message });
                } else if (error.type === 'login') {
                  // failed login request
                  if (error.formattedError === 'invalidEmail') {
                    this.setState({ emailValidationError: error.message });
                  } else {
                    this.setState({ passwordValidationError: error.message });
                  }
                }
              }}
              handleSignupConfirmed={this.showAdditionalStep(
                CONTENT_TYPE.SOCIAL_CONNECT_AGE_COLLECTION,
              )}
              handleShowLogin={() => {
                changeWindowLocation(this.getLoginUrl());
              }}
              showRegisterLoadingScreen={this.showSignupWelcomeLoadingFn}
            />
          </Box>
        )}
      </div>
    );
  }
}

InspiredWallSignup.contextTypes = {
  country: PropTypes.string,
  origin: PropTypes.string,
};

export default compose(
  withUnauthSeoExperiments,
  withRequestContext,
)(InspiredWallSignup);
